import { CommonInputControlDirective } from 'app/shared/directives/control/common-input-control.directive';
import { Component, EventEmitter, forwardRef, Injector, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

/* eslint-disable indent */
@Component({
    selector: 'kh-switch',
    styleUrls: ['./switch.component.less'],
    templateUrl: './switch.component.html',
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SwitchComponent),
            multi: true
        }],
    standalone: false
})
/* eslint-enable indent */
export class SwitchComponent extends CommonInputControlDirective {
  @Input() public testId: string = 'switch-checkbox';
  @Output() public isChecked = new EventEmitter<boolean>();

  public constructor(injector: Injector) {
    super(injector);
  }

  public emitSwitchValue(value: Event): void {
    this.isChecked.emit((value.target as HTMLInputElement).checked);
  }
}
